import { render, staticRenderFns } from "./attenshif2.vue?vue&type=template&id=339fae5c&scoped=true&"
import script from "./attenshif2.vue?vue&type=script&lang=js&"
export * from "./attenshif2.vue?vue&type=script&lang=js&"
import style0 from "./attenshif2.vue?vue&type=style&index=0&id=339fae5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339fae5c",
  null
  
)

export default component.exports